export const overflowHiddenCallbacks = {
  setStyle: () => {
      document.body.style.overflow = 'hidden';
  },
  removeStyle: () => {
      document.body.style = null;
  }
};